import {Component, OnDestroy} from '@angular/core';
import {LoaderService} from "./loader.service";
import {ProgressBarMode, MatProgressBarModule} from '@angular/material/progress-bar';
import { MaterialModule } from 'src/app/app.materials';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  standalone: true,
  imports: [MaterialModule, AsyncPipe, CommonModule]
})
export class LoadingBarComponent implements OnDestroy {

  mode: ProgressBarMode = 'determinate';
  value = 50;
  bufferValue = 75;
  constructor(public loaderService: LoaderService) { }

  ngOnDestroy(): void {
    // No cleanup needed for this component
  }

}
